<div class="container-fluid customers-root">
    <div class="stats-root">
      <div *ngIf="currentTab == 2" class="stats-item">
        <div>
          {{ "COMMON.TOTAL" | translate }}
          {{ "ROLE_MANAGEMENT.SITE_VERIFICATION" | translate  }}
        </div>
        <div>{{ serviceOrderStats?.total | number }}</div>
      </div>
      <div *ngIf="currentTab == 2" class="stats-item">
        <div>
          {{ "COMMON.ASSET_STATUS.ASSIGNED" | translate }}
          {{ "ROLE_MANAGEMENT.SITE_VERIFICATION" | translate }}
        </div>
        <div>{{ serviceOrderStats?.assigned | number }}</div>
      </div>
      <div *ngIf="currentTab == 2" class="stats-item">
        <div>
          {{ "COMMON.ASSET_STATUS.APPROVED" | translate }}
          {{ "ROLE_MANAGEMENT.SITE_VERIFICATION" | translate }}
        </div>
        <div>{{ serviceOrderStats?.approved | number }}</div>
      </div>
      <div *ngIf="currentTab == 2" class="stats-item">
        <div>
          {{ "COMMON.ASSET_STATUS.REJECTED" | translate }}
          {{ "ROLE_MANAGEMENT.SITE_VERIFICATION" | translate  }}
        </div>
        <div>{{ serviceOrderStats?.rejected | number }}</div>
      </div>
      <div *ngIf="currentTab == 2" class="stats-item">
        <div>
          {{ "COMMON.KYC_STATUS_OPTIONS.SUSPENDED" | translate }}
          {{ "ROLE_MANAGEMENT.SITE_VERIFICATION" | translate  }}
        </div>
        <div>{{ serviceOrderStats?.suspended | number }}</div>
      </div>      
    </div>
    <div class="table-root">
      <div class="d-flex justify-content-start switch-toggle transparent">
        <a *ngIf="permissionsService.isNewServiceViewAllowed" class="separated-toggle-item" [ngClass]="currentTab == 1 ? 'active' : ''" (click)="changeTab(1)">
          <div><span class="bubble">{{ customerStats?.newConnection | number }}</span> {{'COMMON.CUSTOMER.NEW_CONNECTION' |
            translate}}</div>
        </a>
        <a *ngIf="permissionsService.isSiteVerificationViewAllowed" class="separated-toggle-item" [ngClass]="currentTab == 2 ? 'active' : ''" (click)="changeTab(2)">
          <div><span class="bubble">{{ serviceOrderStats?.total | number }}</span> Site Verification</div>
        </a>
        <a *ngIf="permissionsService.isServiceRequestAuthViewAllowed" class="separated-toggle-item" [ngClass]="currentTab == 3 ? 'active' : ''" (click)="changeTab(3)">
          <div><span class="bubble">{{ serviceConnectionChargesCount | number }}</span> Service Request Authorization</div>
        </a>
        <a *ngIf="permissionsService.isOnboardedCustomersViewAllowed" class="separated-toggle-item" [ngClass]="currentTab == 4 ? 'active' : ''" (click)="changeTab(4)">
          <div><span class="bubble">{{ customerStats?.onboardedCustomers | number }}</span> {{'NEW_SERVICE.ONBOARD_CUSTOMERS' |
            translate}}</div>
        </a>
        <a *ngIf="permissionsService.isServiceRequestTrackerViewAllowed" class="separated-toggle-item" [ngClass]="currentTab == 5 ? 'active' : ''" (click)="changeTab(5)">
          <div><span class="bubble">{{ serviceRequestTrackerCount | number}}</span> {{'NEW_SERVICE.SERVICE_REQUEST_TRACKER' | translate}}</div>
        </a>
        </div>
      <app-new-connection-and-onboarder-list [activeTab]="currentTab" *ngIf="currentTab == 1"></app-new-connection-and-onboarder-list>
      <app-service-order-list *ngIf="currentTab == 2"></app-service-order-list>
      <app-service-connection-charge-list *ngIf="currentTab == 3"></app-service-connection-charge-list>
      <app-onboarded-customer *ngIf="currentTab == 4"></app-onboarded-customer>
      <app-service-request-tracker *ngIf="currentTab == 5"></app-service-request-tracker>
    </div>
</div>
    